/* istanbul ignore file */
export { default } from './CisPointOfEntry';
